import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "10", height: "7", x: "12", y: "13.5", ry: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PictureInPicture";
const PictureInPicture = memo(themed(Icon));
export {
  PictureInPicture
};
//# sourceMappingURL=picture-in-picture.js.map
